import { mapGetters } from 'vuex'
import Progress from './progress.dialog.vue'
import Add from './add.dialog.vue'
import addPre from './addPre.dialog.vue'
import { vissue, issue, volume } from '@/api/vissue'
import journal from '@/api/journal'
import article from '@/api/article'
import crossref from '@/api/crossref'
import help from '@/utils/help'
const columns = [
  {
    title: '',
    enTitle: '',
    width: 100,
    dataIndex: 'cover',
    slot: 'img',
  },
  {
    title: '',
    enTitle: '',
    width: 220,
    dataIndex: 'name',
    slot: 'name',
  },
  {
    title: '',
    enTitle: '',
    width: 150,
    dataIndex: 'downloadNum',
    slot: 'downloadNum',
  },
  {
    title: '',
    enTitle: '',
    width: 120,
    dataIndex: 'readNum',
    slot: 'readNum',
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 220,
    dataIndex: 'actions',
    slot: 'actions',
  },
]
export default {
  components: {
    Add,
    addPre,
    Progress,
  },
  data() {
    return {
      columns,
      isVisable: false,
      journalList: [],
      volumeList: [],
      issueList: [],
      dataSource: [],
      preDataSource: [],
      inputData: {},
      openSection: '',
      params: {
        released: '',
        journalId: '',
        volumeId: '',
        issueId: '',
      },
      isVisablePre: false,
      isVisableProgress: false,
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      domain: 'getDomain',
      user: 'getUser',
    }),
  },
  async mounted() {
    await this.getJournalList()
  },
  methods: {
    async getList(flag = false) {
      this.params.prePublishered = false
      this.dataSource = await vissue.getAll(this.params)
      this.params.prePublishered = true
      this.preDataSource = await vissue.getAll(this.params)
      if (this.dataSource && this.dataSource.length && flag) {
        this.openSection = this.dataSource[0].id
      }
    },
    async getJournalList() {
      this.journalList = await journal.userGet({ released: true })
      const flag = this.journalList.some((item) => {
        if (item.id === localStorage.getItem('journalId')) {
          this.params.journalId = item.id
          return true
        }
      })
      if (!flag) {
        this.params.journalId = this.journalList[0] && this.journalList[0].id
        localStorage.setItem('journalId', this.params.journalId)
      }
      if (!this.params.journalId) {
        return
      }
      this.getVolumeCode(this.params.journalId)
    },
    async getVolumeCode(journalId) {
      this.volumeList = await volume.getCode({ journalId })
      this.params.volumeId = ''
      this.params.issueId = ''
      localStorage.setItem('journalId', journalId)
      this.getList(true)
    },
    getIssueCode(val) {
      const arr = this.volumeList.find((item) => {
        if (item.id === val) {
          return item
        }
      })
      this.issueList = arr.issueCodeList
      this.params.issueId = ''
      this.getList()
    },
    changeStatus(status) {
      this.params.released = status
      this.getList()
    },
    add() {
      this.isVisable = true
      this.inputData = JSON.parse(JSON.stringify(this.params))
    },
    edit(val) {
      this.$refs['volume-issue-add'].getQuery(val.id)
      this.isVisable = true
      this.inputData = JSON.parse(JSON.stringify(this.params))
    },
    async able(val) {
      const { id, released, version } = val
      await issue.release(id, !released, { version })
      let content = 'This Volume Issue has been published!'
      if (released) {
        content = 'This Volume Issue has been unpublished!'
      }
      this.$message.success({
        title: 'Success',
        content: content,
      })
      this.getList()
    },
    del(val) {
      this.$confirm({
        title: 'Are you sure you want to delete this volume issue?',
        content:
          'Please be aware of once this volume issue is deleted, it will never be able to recovered.',
        type: 'danger',
        icon: 'iconDelete',
      }).then(async () => {
        await issue.del(val.id)
        this.$message.success({
          title: 'Success',
          content: 'This Volume Issue has been deleted!',
        })
        this.getList()
      })
    },
    async setSort(val) {
      val.forEach((item, index) => {
        item.sort = index
      })
      await issue.setSort(val)
      this.getList()
    },
    confirm() {
      this.getList()
      this.isVisable = false
      this.isVisablePre = false
    },
    cancel() {
      this.isVisable = false
      this.isVisablePre = false
      this.isVisableProgress = false
    },
    selectSection(id) {
      if (this.openSection === id) {
        this.openSection = ''
      } else {
        this.openSection = id
      }
    },
    async exportXML(val, type) {
      let data = {
        id: val.id,
        type: type,
      }
      let res = await issue.export(data)
      help.download(res.url, res.fileName)
    },
    addPre() {
      this.isVisablePre = true
    },
    updateXML(val) {
      this.$confirm({
        title: 'Update XML',
        content: 'Are you sure you want to update the XML?',
        type: 'warning',
        icon: 'iconDetails',
      }).then(async () => {
        const res = await article.issueXML(val.id)
        this.isVisableProgress = true
        this.inputData = { id: res }
      })
    },
    async updateDOI(val) {
      if (val.doied) {
        this.$message.error({
          title: 'Error',
          content: 'DOI have already registered!',
        })
        return
      }
      const count = await crossref.doiCount({
        issueId: val.id,
        doied: false,
      })
      this.$confirm({
        title: 'Register DOI',
        content: 'Are you sure to register DOI？Registrable DOI: ' + count,
        type: 'warning',
        icon: 'iconDetails',
      }).then(async () => {
        await crossref.issueDoi({
          issueId: val.id,
          version: val.version,
        })
        this.$message.success({
          title: 'Success',
          content:
            'Operate successfully, the registration result will be sent later.',
        })
        this.getJournalList()
      })
    },
  },
}
